<mat-card appearance="outlined" class="change-set">
    <mat-card-content>
        <mat-accordion>
            <mat-expansion-panel *ngFor="let change of changes; let i = index" [attr.data-testid]="'change-set-list'">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        {{ change.commandClass }}
                    </mat-panel-title>
                    <mat-panel-description>
                        <div class="panel-description">
                            {{ change.description }}
                        </div>
                    </mat-panel-description>
                </mat-expansion-panel-header>
                <br/>
                <emm-change
                    [featureScope]="featureScope"
                    [lastChange]="lastChange"
                    [change]="change"
                ></emm-change>
            </mat-expansion-panel>
        </mat-accordion>
        <mat-paginator
            #paginator
            *ngIf="changeCount > pageSize"
            [length]="changeCount"
            [pageSize]="pageSize"
            (page)="page($event)"
            showFirstLastButtons
        ></mat-paginator>
    </mat-card-content>
</mat-card>
